<template>
  <div>
    <div style="width:100%;padding:0;">
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-12">
          <div class="row">
            <div
              class="col-lg-6 col-md-6 col-sm-12"
              v-if="$root.courseStatus ==='InSession'"
            >
              <home-shared-calendar />
            </div>
            <div
              class="col-lg-6 col-md-6 col-sm-12"
              v-if="$root.courseStatus ==='InSession'"
            >
              <announcement-viewer
                :include-participant="announcmentFilter.includeParticipants"
                :include-staff="announcmentFilter.includeStaff"
                :include-drafts="announcmentFilter.includeDrafts"
                :include-welcome-letter="announcmentFilter.includeWelcomeLetter"
              />
            </div>
            <div
              class="col-12"
              v-if="$root.courseStatus !== 'InSession'"
            >
              <announcement-viewer
                :include-participant="announcmentFilter.includeParticipants"
                :include-staff="announcmentFilter.includeStaff"
                :include-drafts="announcmentFilter.includeDrafts"
                :include-welcome-letter="announcmentFilter.includeWelcomeLetter"
              />
            </div>
          </div>
        </div>
        <div
          class="col-lg-4 col-md-4 col-sm-12"
        >
          <home-shared-course />
          <home-shared-tasks v-if="$root.courseStatus === 'PreCourse'" />
          <home-participant-goals v-if="$root.courseStatus !== 'PreCourse'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeSharedCourse from '@/components/_home-page/shared/home-shared-course.vue'
import HomeSharedTasks from '@/components/_home-page/shared/home-shared-tasks.vue'
import HomeParticipantGoals from '@/components/_home-page/participant/home-participant-goals.vue'
import AnnouncementViewer from '@/components/announcements/announcement-viewer.vue'
import HomeSharedCalendar from '@/components/_home-page/shared/home-shared-calendar.vue'

export default {
  name: 'ParticipantHomePage',
  components: {
    HomeSharedCourse,
    HomeSharedTasks,
    AnnouncementViewer,
    HomeSharedCalendar,
    HomeParticipantGoals
  },
  data: function () {
    return {
      announcmentFilter: {
        includeParticipants: true,
        includeStaff: false,
        includeDrafts: false,
        includeWelcomeLetter: true
      }
    }
  }
}
</script>
